import type { NewApptState } from '../types';

export const selectCallbackUrl = (state: NewApptState) => state.newAppt.callbackUrl;
